import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import NavbarForOnboardingForm from "./onboarding/NavbarForOnbardingForm";
import { useLoading } from "./LoadingContext";

function EditClient() {
  const navigate = useNavigate();
  const { id } = useParams(); // Get the job id from the URL parameters

  const [clientData, setClientData] = useState({
    client_id: "",
    client_name: "",
    client_country: "",
    client_city: "",
    client_contact_number: "",
    client_mail_id: "",
    client_contact_person: "",
    client_contact_person_mail_id: "",
    client_contact_person_phone_number: "",
    engagement_type: "",
  });

  const { loading, setLoading } = useLoading();
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setClientData({ ...clientData, [e.target.name]: e.target.value });
  };

  const handleEdit = (event) => {
    event.preventDefault();

    axios
      .patch(
        `${process.env.REACT_APP_API_BASE_URL}/client-api/clients/${id}/update/`,
        clientData
      )
      .then((response) => {
        // console.log(response.data);
        navigate("/client_dashboard");
      })
      .catch((error) => {
        // Check if the error response and the message exist
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          alert(error.response.data.message); // Show the backend error message
        } else {
          alert("An unexpected error occurred. Please try again."); // Fallback error message
        }
        console.error(error);
      });
  };

  // Fetch client data based on the id from your API
  useEffect(() => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/client-api/clients/${id}/`)
      .then((response) => {
        setClientData(
          response.data.data || {
            client_id: "",
            client_name: "",
            client_country: "",
            client_city: "",
            client_contact_number: "",
            client_mail_id: "",
            client_contact_person: "",
            client_contact_person_mail_id: "",
            client_contact_person_phone_number: "",
            engagement_type: "",
          }
        );
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        if (error.response?.data?.message) {
          alert(error.response.data.message); // Show the backend error message
        } else {
          alert("An unexpected error occurred. Please try again."); // Fallback error message
        }
        setError(error);
        setLoading(false);
      });
  }, [id]);

  if (loading) {
    return (
      <div
        className="container d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div>
          <div
            className="spinner-border text-dark"
            role="status"
            style={{ width: "3rem", height: "3rem" }}
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
        <h3 className="text-center text-dark">&nbsp;Data is Fetching.... </h3>
      </div>
    );
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }
  return (
    <>
      <NavbarForOnboardingForm />
      <div className="container py-5">
        <div className="row d-flex justify-content-center align-items-center h-100">
          <div className="col-10 col-md-8 col-lg-6 col-xl-6 log">
            <div className="card border border-dark text-white">
              <div
                className="card-header border-dark"
                style={{ background: "#008cba" }}
              >
                <h4 className="text-center font_header">Update Client Form</h4>
              </div>
              <div className="card-body">
                <form onSubmit={handleEdit} className="text-dark">
                  <div className="mb-2">
                    <div className="row">
                      <div className="col-md-6">
                        <label htmlFor="client_id" className="form-label">
                          Id
                        </label>
                        <input
                          type="text"
                          className="form-control border-dark text-dark"
                          id="client_id"
                          name="client_id"
                          aria-describedby="emailHelp"
                          value={clientData.client_id}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <div data-mdb-input-init className="form-outline">
                          <label className="form-label" htmlFor="client_name">
                            Name
                          </label>
                          <input
                            type="text"
                            id="client_name"
                            name="client_name"
                            className="form-control border-dark text-dark"
                            value={clientData.client_name}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mb-2">
                    <div className="row">
                      <div className="col-md-6">
                        <div data-mdb-input-init className="form-outline">
                          <label
                            className="form-label"
                            htmlFor="client_country"
                          >
                            Country
                          </label>
                          <input
                            type="text"
                            id="client_country"
                            name="client_country"
                            className="form-control border-dark text-dark"
                            value={clientData.client_country}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="client_mail_id" className="form-label">
                          Mail Id
                        </label>
                        <input
                          type="mail"
                          className="form-control border-dark text-dark"
                          id="client_mail_id"
                          name="client_mail_id"
                          aria-describedby="emailHelp"
                          value={clientData.client_mail_id}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mb-2">
                    <div className="row">
                      <div className="col-md-6">
                        <label
                          htmlFor="client_contact_number"
                          className="form-label"
                        >
                          Contact Number
                        </label>
                        <input
                          type="tel"
                          className="form-control border-dark text-dark"
                          id="client_contact_number"
                          name="client_contact_number"
                          aria-describedby="emailHelp"
                          // pattern="(\+91)?[6-9][0-9]{9}"
                          value={clientData.client_contact_number}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="client_city" className="form-label">
                          City
                        </label>
                        <input
                          type="text"
                          className="form-control border-dark text-dark"
                          id="client_city"
                          name="client_city"
                          aria-describedby="emailHelp"
                          value={clientData.client_city}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="mb-2">
                    <div className="row">
                      <div className="col-md-6">
                        <label
                          htmlFor="client_contact_person"
                          className="form-label"
                        >
                          Contact Person
                        </label>
                        <input
                          type="text"
                          className="form-control border-dark text-dark"
                          id="client_contact_person"
                          name="client_contact_person"
                          aria-describedby="emailHelp"
                          value={clientData.client_contact_person}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          htmlFor="client_contact_person_mail_id"
                          className="form-label"
                        >
                          Contact Person Mail Id
                        </label>
                        <input
                          type="email"
                          className="form-control border-dark text-dark"
                          id="client_contact_person_mail_id"
                          name="client_contact_person_mail_id"
                          aria-describedby="emailHelp"
                          value={clientData.client_contact_person_mail_id}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="mb-2">
                    <div className="row">
                      <div className="col-md-6">
                        <label htmlFor="engagement_type" className="form-label">
                          Engagement Type
                        </label>
                        <input
                          type="text"
                          className="form-control border-dark text-dark"
                          id="engagement_type"
                          name="engagement_type"
                          aria-describedby="emailHelp"
                          value={clientData.engagement_type}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          htmlFor="client_contact_person_phone_number"
                          className="form-label"
                        >
                          Contact Person Phone Number
                        </label>
                        <input
                          type="text"
                          className="form-control border-dark text-dark"
                          id="client_contact_person_phone_number"
                          name="client_contact_person_phone_number"
                          aria-describedby="emailHelp"
                          value={clientData.client_contact_person_phone_number}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="text-center py-2">
                    <button
                      type="submit"
                      className="btn btn-outline-info me-2"
                      onClick={handleEdit}
                    >
                      Submit
                    </button>
                    <button
                      className="btn btn-outline-danger"
                      type="button"
                      onClick={() => navigate("/client_dashboard")}
                    >
                      Close
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditClient;
